import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, Phone } from 'lucide-react';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#e8f5ef] via-[#f0f9f4] to-white">
      <section className="pt-20 py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-2xl mx-auto">
            <div className="mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-100 rounded-full mb-6">
                <XCircle className="h-12 w-12 text-orange-600" />
              </div>
              
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Paiement annulé
              </h1>
              
              <p className="text-xl text-gray-600 mb-8">
                Vous avez annulé le processus de paiement
              </p>
            </div>

            <Card className="mb-8">
              <CardContent className="p-8">
                <div className="text-left space-y-4">
                  <p className="text-gray-700">
                    Votre abonnement n'a pas été créé car le paiement n'a pas été finalisé.
                  </p>
                  <p className="text-gray-700">
                    Pas d'inquiétude ! Vous pouvez reprendre le processus à tout moment ou nous contacter si vous avez des questions.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardContent className="p-8">
                <h3 className="font-bold text-lg mb-4">Besoin d'aide ?</h3>
                <div className="text-left space-y-4">
                  <div className="flex items-start space-x-3">
                    <Phone className="h-5 w-5 text-[#52a675] mt-1" />
                    <div>
                      <p className="font-semibold text-gray-900">Contactez-nous</p>
                      <p className="text-gray-600">
                        Notre équipe est disponible pour répondre à vos questions
                      </p>
                      <a href="tel:0229809393" className="text-[#52a675] hover:underline font-semibold">
                        022 980 93 93
                      </a>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={() => navigate('/abonnements')}
                className="bg-[#52a675] hover:bg-[#4a9566]"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Reprendre ma souscription
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/')}
              >
                Retour à l'accueil
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SubscriptionCancelPage;
